import React from "react";
import ServiceCard from "./subscription-card";
import { Box } from "@mui/material";
import SubscriptionCard from "./subscription-card";

const Subscriptions = ({ data,type }) => {
  return (
    <Box sx={{ p: 3 }} className="flex flex-col w-full gap-5">
      {data?.length === 0 ? (
        <div className="text-start">{type === 'all' ? "There are no Subscription yet" : "There are no Active Subscription yet"}</div>
      ) : (
        data?.map((item, idx) => {
          return (
            <div key={idx}>

              <SubscriptionCard data={item} />

            </div>
          );
        })
      )}
    </Box>
  );
};

export default Subscriptions;
